import React, {Component} from 'react';
import {Table} from "reactstrap";
import 'moment/locale/fr';
import './Products.css'
import {Activity, Edit2, Filter, Trash} from "react-feather";
import {Col, OverlayTrigger, Row, Spinner, ToggleButton, ToggleButtonGroup, Tooltip} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import {HiOutlineViewList} from "react-icons/hi";
import DeleteForecastModal from "./modals/DeleteForecastModal";
import AddForecastModal from "./modals/AddForecastModal";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import Moment from "moment";

function getForecasts() {

    return fetch('https://back-api.therunningcollective.fr/forecasts', {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
        },
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}


function updateState(forecast, checked) {
    forecast.active = checked
    return fetch('https://back-api.therunningcollective.fr/forecast', {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(forecast)
    }).then()
        .catch( err =>
            console.log(err)
        )
}

export class ForecastsList extends Component {
    state = {
        errors: null,
        selectedForecast: {
            name: "",
            description: "",
            beginDate: "",
            endDate: "",
            cover: "",
        },
    }

    async componentDidMount() {
        await getForecasts().then(data => {
            this.setState({forecasts: data})
        }).catch(err =>
            this.setState({errors: "error while getting forecasts"})
        );
    };

    closeModal = () => this.setState({
        isOpen: false,
        isDelete: false,
        isDrawing: false,
        selectedForecast: {
            title: "",
            body: "",
        }
    });


    render() {
        return (
            <div className="products-list">
                <Row>
                    <Col sm={11} className="products-buttons">
                        <Button className="add-product-button " variant="secondary" type="submit"
                                onClick={(e) => this.setState({isOpen: true})}>Ajouter un pronostic</Button>
                    </Col>
                    
                    <Col sm={1} className="products-buttons">
                        <ToggleButtonGroup value={this.state.mode} type="checkbox">
                            <ToggleButton
                                key={2}
                                type="radio"
                                variant="secondary"
                                name="radio"
                                value={"Liste"}
                                onChange={(e) => this.setState({mode: e.currentTarget.value})}
                            >
                                <HiOutlineViewList/>
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Col>
                </Row>
                <Row>
                    <Col sm={11} className="products-buttons">
                        {(this.state.forecasts && this.state.forecasts.length > 0 && this.state.errors == null) ? <span>{this.state.forecasts.length} pronostic(s)</span> : null }
                    </Col>
                </Row>
                { this.state.errors != null ? <p>"Erreur lors de la récupération des pronostics, veuillez vous reconnecter"</p> : null}

                { (!this.state.forecasts && this.state.errors == null) ? <p> Chargement ...</p>
                    :
                    <Table responsive>
                        <thead>
                        <tr>
                            <th>Afficher</th>
                            <th>Nom</th>
                            <th>Description</th>
                            <th>Date de début</th>
                            <th>Date de fin</th>
                            <th>Inscriptions</th>
                            <th>Lancement</th>
                            <th>Nb d'inscrits</th>
                            <th>Fond d'écran</th>
                            <th>Couverture</th>
                            <th>Bannière</th>
                            <th></th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.forecasts.map(forecast => (
                            <tr>
                                <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip id="button-tooltip">Afficher le pronostic sur le site</Tooltip>}
                                        >
                                            <td><BootstrapSwitchButton
                                                checked={forecast.active}
                                                onlabel='oui'
                                                onstyle='success'
                                                offlabel='non'
                                                offstyle='danger'
                                                size='xs'
                                                onChange={(checked: boolean) => {
                                                    updateState(forecast, checked)
                                                }}
                                            /></td>
                                        </OverlayTrigger>
                                <td>{forecast.name}</td>
                                <td>{forecast.description}</td>
                                <td>{Moment(forecast.beginDate).format('YYYY-MM-DDTHH:mm').toString()}</td>
                                <td>{Moment(forecast.endDate).format('YYYY-MM-DDTHH:mm').toString()}</td>
                                <td>{forecast.openSignIn ? "Activé" : "Non activé"}</td>
                                <td>{forecast.officiallyLaunched ? "Activé" : "Non activé"}</td>
                                <td>{forecast.attendeesCount}</td>
                                <td>
                                    {
                                        forecast.backgroundImage && forecast.backgroundImage != "" ?
                                            <img style={{
                                                maxWidth: '100px',
                                            }} src={forecast.backgroundImage}/>
                                        : null
                                    }
                                </td>
                                <td>
                                    {
                                        forecast.cover && forecast.cover != "" ?
                                            <img style={{
                                                maxWidth: '100px',
                                            }} src={forecast.cover}/>
                                        : null
                                    }
                                </td>
                                <td>
                                    {
                                        forecast.bannerImage && forecast.bannerImage != "" ?
                                            <img style={{
                                                maxWidth: '100px',
                                            }} src={forecast.bannerImage}/>
                                        : null
                                    }
                                </td>
                                <OverlayTrigger
                                        placement="top"
                                        overlay={<Tooltip id="button-tooltip">Modifier l'ajout de pronsotic</Tooltip>}
                                    >
                                        <td className="table-action" style={{cursor: "pointer"}}>
                                            <Edit2 className="align-middle mr-1" size={18}
                                                onClick={(e) => this.setState({isOpen: true, selectedForecast: forecast})}/>
                                        </td>
                                    </OverlayTrigger>
                                
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="button-tooltip">Supprimer l'ajout du pronsotic</Tooltip>}
                                >
                                    <td className="table-action" style={{cursor: "pointer"}}>
                                        <Trash className="align-middle" size={18}
                                               onClick={(e) => this.setState({isDelete: true, selectedForecast: forecast})}/>
                                    </td>
                                </OverlayTrigger>

                            </tr>
                        ))}
                        </tbody>
                    </Table>
                }
                {this.state.isOpen ?
                    <AddForecastModal
                        closeModal={this.closeModal}
                        isOpen={this.state.isOpen}
                        handleSubmit={this.handleSubmit}
                        selectedForecast={this.state.selectedForecast}
                        availableUsers={this.state.availableUsers}
                        availableTypes={this.state.availableTypes}

                    />
                    :
                    null
                }
                {this.state.isDelete ?
                    <DeleteForecastModal
                        closeModal={this.closeModal}
                        isOpen={this.state.isDelete}
                        handleSubmit={this.handleSubmit}
                        selectedItem={this.state.selectedForecast}
                        selectedCategory="forecast"
                    />
                    :
                    null
                }
            </div>
        );

    }
}